/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { actions } from './';

export default produce((state, action) => {
  switch (action.type) {
    case actions.FETCH:
      if (!state[action.isoCountryCode]) {
        state[action.isoCountryCode] = {};
      }
      state[action.isoCountryCode][action.stateKey] = action.progress;
      break;
    default:
  }
}, {});
